import { formatDayjs } from "../../../services/localeFormat"
import React from "react"

import HebcalService from "../../../services/hebcal"

import {Typography} from "antd";
import moment from "moment"
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import dayjs from "dayjs";

const {Text}=Typography


export default class PreviewHoraires extends React.Component{


  getHoraires()
  {
    const {org}=this.props.context

    var hebcal= new HebcalService(org,new Date(),org.lat,org.long)

    const selectedOrg=org

    if(!selectedOrg || selectedOrg.horaires.length==0){
      return []
    }

    hebcal.generateHebCal()

    var horaires={}

    for(var h of selectedOrg.horaires)
    {
      if(!h.dow){
        continue
      }

      h.dow.forEach((dow)=>{
        if(!horaires[dow]){
          horaires[dow]=[]
        }

        if(h.fixed)
        {
          horaires[dow].push({
            name:h.name,
            heure:h.heure,
            minute:h.minute,
          })
        }else
        {
          var date=new Date()
          date.setDate((date.getDate()- date.getDay()) + parseInt(dow))

          var hz=new Date(hebcal.getVariableZman(h.zeman,date))

          if(hz)
          {
            if(h.avant){
              hz.setMinutes(hz.getMinutes()-h.minute)
            }else{
              hz.setMinutes(hz.getMinutes()+h.minute)
            }

            if(h.round)
            {
              const reste=hz.getMinutes()%5
              if(reste!=0 && reste <2.5){
                hz.setMinutes(hz.getMinutes()-reste)
              }

              if(reste!=0 && reste >=2.5){
                hz.setMinutes(hz.getMinutes()-reste+5)
              }

            }

            // Heure murale dans le fuseau de l'org (pas celui du serveur/navigateur)
            const wc = hebcal.getWallClock(hz) || { heure: hz.getHours(), minute: hz.getMinutes() }

            horaires[dow].push({
              name:h.name,
              heure:wc.heure,
              minute:wc.minute,
            })
          }

        }
      })
    }

    var sorted=[]

    for(var dow of Object.keys(horaires).sort())
    {
      var date=new Date()
      date.setDate((date.getDate()- date.getDay()) + parseInt(dow))

      sorted.push({
        dow:dow,
        date:date,
        items:horaires[dow].sort((a,b)=>{
          var datea=new Date()
          datea.setHours(a.heure,a.minute)

          var dateb=new Date()
          dateb.setHours(b.heure,b.minute)

          if(datea==dateb){
            return 0
          }
          return datea<dateb?-1:1
        })

      })
    }

    return sorted
  }


  getDailyHoraires(horaires)
  {
    if(horaires.length==0){
      return null
    }

    var date=new Date()
    var item=horaires.find((d)=>d.dow==date.getDay())

    if(!item || !this.getNextHoraires(item.items,date))
    {
      if(horaires.find(d=>d.dow>date.getDay()))
      {
        item=horaires.find((d)=>d.dow>date.getDay())
        date=new Date(item.date)

      }else if(horaires.find(d=>d.dow<date.getDay()))
      {
        item=horaires.find((d)=>d.dow<date.getDay())
        date=new Date(item.date)

      }else
      {
        return null
      }
    }

    return this.getNextHoraires(item.items,date)

  }


  getNextHoraires(items,date)
  {

    if(!moment(date).isSame(moment(), 'day'))
    {
      if(items){
        return{
          date:date,
          horaires:items
        }
      }
      return null
    }

    var minDate=new Date()
    minDate.setMinutes(minDate.getMinutes()-15)

    var finalItems=items.filter((item)=>{
      var hdate=new Date(date)
      hdate.setHours(item.heure)
      hdate.setMinutes(item.minute)

      return hdate.getTime()>=minDate.getTime()
    })

    if(finalItems.length>0){
      return{
        date:date,
        horaires:finalItems
      }
    }

    return null
  }

  render()
  {
    const context=this.props.context
    const {org}=context

    const data=this.getDailyHoraires(this.getHoraires())

    if(!data){
      return null
    }


    return (
        <div className="wpo-about-area section-padding">
          <div className="container">
            <div className="timer-section">
              <div className="row">
                <div className="col-lg-5">
                  <div className="timer-text">
                    <h2><Trans>Nos Horaires</Trans></h2>
                    <p>{t`pour la ville de ${org.ville}`}</p>
                    <span>{t`le ${formatDayjs(data.date, context.langValue, 'dddd DD MMMM')}`}</span>
                  </div>
                </div>
                <div className="col-lg-5 offset-lg-1">
                  <div className="timer-num">
                    <ul>
                      {
                        data.horaires.map((h,index)=>{
                          var showTime=false

                          var hdate=new Date(data.date)
                          hdate.setHours(h.heure,h.minute,0)

                          var minDate=new Date()
                          minDate.setMinutes(minDate.getMinutes()-15)

                          if(hdate.getTime()>minDate.getTime() && (hdate.getTime()-minDate.getTime())/1000 < 45*60)
                          {
                            showTime=true
                          }

                          return (
                              <li key={index}>
                                <span className="title-horaire">{h.name}</span>
                                {showTime &&(
                                    <span style={{color:"red"}}><TimeUpdate time={hdate.getTime()}/></span>
                                )}
                                {!showTime &&(
                                    <span>
                                      {dayjs()
                                          .hour(h.heure)
                                          .minute(h.minute)
                                          .locale(context.langValue === 'gr' ? 'el' : context.langValue.split('-')[0])
                                          .format('LT')}
                                    </span>
                                )}
                              </li>
                          )
                        })
                      }

                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
    )

  }
}

class TimeUpdate extends React.Component{

  constructor(props)
  {
    super(props)

    this.state={
      time:props.time
    }
  }

  componentDidMount(){
    this.interval=setInterval(()=>this.forceUpdate(),500)
  }

  componentWillUnmount(){
    if(this.interval){
      clearInterval(this.interval)
    }
  }

  render()
  {

    var diff=(this.state.time-new Date().getTime())

    if(diff<0)
    {
      return <Trans>Maintenant</Trans>
    }

    var msec = diff;
    var mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    var ss = Math.floor(msec / 1000);
    msec -= ss * 1000;


    return <Trans>Dans {("0"+mm).slice(-2)}:{("0"+ss).slice(-2)}</Trans>
  }

}
